<template>
  <div id="BuildingEdit">
    <div class="headLine">新增产业空间信息</div>
    <div v-if="auditRecord != ''" class="backLine">
      退回原因：{{ auditRecord }}
    </div>
    <div class="navLine">
      <div @click="navChange(1)" :class="['navItem', { act: navAct == 1 }]">
        楼宇信息
      </div>
      <div @click="navChange(2)" :class="['navItem', { act: navAct == 2 }]">
        <span>空间信息（{{ floors }}）</span>
      </div>
    </div>

    <div class="pgContent">
      <Buliding ref="buliding" :resData="resData" :hidden="navAct == 2" />
      <Floor
        ref="floor"
        :resData="resData"
        :hidden="navAct == 1"
        @floors="floorChange"
      />
    </div>

    <div class="pgFooter">
      <el-button
        @click="bulidingSave(4)"
        :loading="loading"
        type="primary"
        size="small"
        >保存</el-button
      >
      <el-button @click="bulidingSave(5)" :loading="loading" size="small"
        >提交审核</el-button
      >
      <el-button @click="pgBack" size="small">取消</el-button>
    </div>
  </div>
</template>
<script>
import { buldingCreate, floorCreate, getBuildingInfos } from '@/api/industryInfos';
import Buliding from './components/buildingSave';
import Floor from './components/floorSave';
export default {
  components: {
    Buliding,
    Floor
  },
  data() {
    return {
      navAct: 1,
      floors: 0,
      resData: '',
      auditRecord: '',
      loading: false,
    }

  },
  methods: {

    navChange(act) {
      this.navAct = act;
    },

    async bulidingSave(state) {
      var vues = this;

      let res1 = await this.$refs.buliding.goSave();
      let res2 = await this.$refs.floor.listSave();

      if (!res1.canSave) {
        this.$message.error('楼宇信息填写不完整！');
      } else if (!res2.length) {
        this.$message.error('空间信息不能为空！')
      } else {
        this.loading = true;
        res1.data.status = state;
        if (state == 5) {
          res1.data.auditRecord = '';
        }

        buldingCreate({ industrialSpace: res1.data }).then(tempRes => {
          res1.id = tempRes.id;
          res2.forEach(item => {
            item.industrialSpaceId = tempRes.industrialSpace.id;
            item.id = '';
          });
          floorCreate({ industrialSpaceFloorList: res2 }).then(res => {
            vues.loading = false;
            this.$message.success('操作成功！');
            this.$router.go(-1);
          });
        }, error => {
          vues.loading = false;
        })

      }

    },

    floorChange(e) {
      this.floors = e;
    },

    pgBack() {
      this.$router.go(-1);
    }
  },
  created() {
    let querys = this.$route.query;
    if (querys.id) {
      getBuildingInfos({ id: querys.id }).then(res => {
        this.resData = res;
        this.auditRecord = res.industrialSpace.auditRecord;
      })
    }
  }
}
</script>
<style lang='scss' scoped>
#BuildingEdit {
  font-size: 15px;

  .navLine {
    padding-left: 20px;
    border-bottom: 1px solid #ebeef5;
    .navItem {
      height: 54px;
      font-size: 14px;
      margin: 0 30px;
      display: inline-block;
      line-height: 54px;
      border-bottom: 2px solid white;
      cursor: pointer;
      &.act {
        color: #409eff;
        border-color: #409eff;
      }
    }
  }
  .headLine {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #ebeef5;
  }
  .backLine {
    padding: 0 20px;
    height: 60px;
    color: red;
    line-height: 60px;
    border-bottom: 1px solid #ebeef5;
  }
  .tabSet {
    position: relative;
    text-align: center;
    border-top: 1px dotted #ebeef5;
    border-bottom: 1px dotted #ebeef5;
    padding: 30px 0;
    margin-top: 20px;
    margin-bottom: 50px;
  }

  .tbAdd {
    width: 120px;
    width: 80%;
    margin-top: 20px;
    border: 1px dotted #dcdfe6;
  }

  .pgFooter {
    padding: 30px 20px;
    .el-button {
      width: 80px;
    }
  }
}
</style>

<style lang="scss">
#BuildingEdit {
  .el-input__inner {
    border-radius: 0px;
  }
  .dHead {
    background: #f5f5f5;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?18d76754